<div>
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <form [formGroup]="formGroup" (submit)="submit()" class="tw-p-4">
    <div mat-dialog-title class="matp-dialog-title">
      テナント{{ updating ? "編集" : "新規登録" }}
    </div>

    <mat-dialog-content class="tw-w-full !tw-pt-2">
      <div class="tw-flex tw-gap-x-4">
        <div class="tw-flex tw-flex-col tw-gap-y-2 tw-w-full">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>テナント名</mat-label>
            <input
              matInput
              formControlName="tenantName"
              placeholder="例）マクニカ"
              id="tenant-name"
              name="tenantName"
              [disabled]="updating"
              required
            />
            <mat-error
              *ngIf="formGroup.controls.tenantName.errors?.['required']"
            >
              テナント名を入力してください。
            </mat-error>
            <mat-error
              *ngIf="formGroup.controls.tenantName.errors?.['maxlength']"
            >
              128文字以下で入力してください。
            </mat-error>
            <mat-error
              *ngIf="formGroup.controls.tenantName.errors?.['isDuplicated']"
            >
              既存のテナントと別の名前を入力してください。
            </mat-error>
          </mat-form-field>

          <div class="tw-h-4"></div>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>会社名</mat-label>
            <input
              matInput
              formControlName="companyName"
              placeholder="例）株式会社マクニカ"
              id="company-name"
              name="companyName"
              required
            />
            <mat-error
              *ngIf="formGroup.controls.companyName.errors?.['required']"
            >
              会社名を入力してください。
            </mat-error>
            <mat-error
              *ngIf="formGroup.controls.companyName.errors?.['maxlength']"
            >
              128文字以下で入力してください。
            </mat-error>
          </mat-form-field>

          <div class="tw-h-4"></div>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>説明</mat-label>
            <textarea
              matInput
              formControlName="description"
              placeholder=""
              id="description"
              name="description"
              rows="3"
            ></textarea>
            <mat-error
              *ngIf="formGroup.controls.description.errors?.['maxlength']"
            >
              1024文字以下で入力してください。
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions class="tw-flex !tw-justify-center !tw-px-6 tw-gap-x-4">
      <button
        id="btn-cancel-add-tenant"
        mat-raised-button
        mat-dialog-close
        class="tw-w-40"
      >
        <mat-icon>close</mat-icon>
        キャンセル
      </button>
      <button
        id="btn-add-tenant"
        mat-raised-button
        color="accent"
        class="tw-w-40"
        type="submit"
        [disabled]="formGroup.invalid"
      >
        <mat-icon>done</mat-icon>
        <span>{{ updating ? "変更" : "新規登録" }}</span>
      </button>
    </mat-dialog-actions>
  </form>
</div>
